import {REPORT_ALL_COACHES_IN_ORGANIZATION} from '/enum/records.enum';

export default {
  reportName: REPORT_ALL_COACHES_IN_ORGANIZATION,
};
